/**
 * Created by smizrahi on 8/17/16.
 */

import Logger from '../utils/Logger'

const SEED_LENGTH = 256;
const SEED_SHORT_LENGTH = 128;

export default class UIDGenerator {

    constructor(persistence, security) {
        Logger.log('UID Generator init');
        this.persistence = persistence;
        this.security = security;

        let uid = this.persistence.loadUID();
        if (uid) {
            this.uid = uid;
        } else {
            // Generates an UID
            let deviceID = this.security.generateDeviceID();
            if (!deviceID) {
                // If no device ID, generates a random seed
                deviceID = this.security.md5(this.security.generateSeed(SEED_LENGTH));
            }
            // UID is a md5 combination of device ID and a short random seed
            this.uid = this.security.md5(deviceID + this.security.generateSeed(SEED_SHORT_LENGTH));
            // Saves the UID into local storage or cookie
            this.persistence.saveUID(this.uid);
        }
        Logger.log('UID : ' + this.uid);
    }

    /**
     * Gives the UID of client
     *
     * @returns {*}
     */
    getUID() {
        return this.uid;
    }

    /**
     * Generates a session ID (SID)
     * A SID is the UID appending current timestamp in milliseconds
     *
     * @returns {string}
     */
    getSID() {
        return this.uid + '-' + Math.round(new Date().getTime());
    }
}




// WEBPACK FOOTER //
// ./js/core/UIDGenerator/UIDGenerator.js